module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('vue-particles', {
    staticStyle: {
      "position": "fixed",
      "left": "0",
      "right": "0",
      "top": "0",
      "bottom": "0",
      "width": "100%",
      "height": "100%",
      "z-index": "0"
    },
    attrs: {
      "color": "#dedede",
      "particleOpacity": 0.85,
      "particlesNumber": 80,
      "shapeType": "triangle",
      "particleSize": 4,
      "linesColor": "#7386D5",
      "linesWidth": 1,
      "lineLinked": true,
      "lineOpacity": 0.4,
      "linesDistance": 150,
      "moveSpeed": 1,
      "hoverEffect": false,
      "hoverMode": "grab",
      "clickEffect": false,
      "clickMode": "push"
    }
  }), _vm._v(" "), _c('sidebar'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('top-navigation'), _vm._v(" "), _c('main-container')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0185bec3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Layout/index.vue
// module id = 1217
// module chunks = 1